import React from 'react';
import backarrow from '../../assets/images/arrow.svg';

export const ModalBackButton = ({ clickAction }) => {
    return (
        <div className="modal-close-button-wrapper">
            <a
                className="modal-close-button"
                onClick={clickAction}
            >
                <img src={backarrow} className="modal-back-icon" />
            </a>
            
        </div>
    );
}